/* * @Author: 曹俊杰 * @Date: 2022-06-08 10:57:28 * @Module: 违约列表组件 */
<template>
  <div class="exposureList">
    <div class="search" v-if="showSearch">
      <el-input
        clearable
        size="small"
        @keyup.enter.native="() => $emit('onSearch')"
        :value="search"
        @input="(value) => $emit('update:search', value)"
        style="width: 220px"
        placeholder="请输入姓名或身份证号"
        prefix-icon="el-icon-search"
      >
      </el-input>

      <el-button-group style="margin-left: 20px">
        <el-button @click="() => $emit('onSearch')" type="primary" size="small"
          >查询</el-button
        >
      </el-button-group>
    </div>
    <el-table
      :data="tableData"
      style="width: 100%"
      row-class-name="defTableRowStyle"
      header-row-class-name="defTableHeaderStyle"
      :default-expand-all="defaultExpandAll"
    >
      <el-table-column type="expand" width="54px">
        <template slot-scope="props">
          <div class="content">
            <h1 style="color: #f45858" v-if="props.row.type === 1">具体情况：</h1>
            <h1 style="color: #722ed1" v-if="props.row.type === 2">具体情况：</h1>
            <h1 style="color: #33d1c9" v-if="props.row.type === 3">具体情况：</h1>
            <p>{{ props.row.content }}</p>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="曝光日期">
        <template slot-scope="scope">
          <span v-if="scope.row.createdAt">{{ scope.row.createdAt | timeFormat }}</span>
          <span v-else>--</span>
        </template>
      </el-table-column>
      <el-table-column label="姓名">
        <template slot-scope="scope">
          <span>{{ scope.row.name }}</span>
        </template>
      </el-table-column>
      <el-table-column label="手机号">
        <template slot-scope="scope">
          <span>{{ scope.row.phone||'--' }}</span>
        </template>
      </el-table-column>
      <el-table-column label="类型">
        <template slot-scope="scope">
          <typeTag :type="scope.row.type" />
        </template>
      </el-table-column>
      <el-table-column label="违约主播身份证号码">
        <template slot-scope="scope">
          <span>{{ scope.row.idNumber }}</span>
        </template>
      </el-table-column>
      <!-- <el-table-column label="曝光方">
        <template slot-scope="scope">
          <span style="color:#666;">{{ scope.row.companyName }}</span>
        </template>
      </el-table-column> -->
      <el-table-column label="曝光账号" width="150">
        <template slot-scope="scope">
          <div class="flex">
            <span style="color: #666">{{ scope.row.empName }}</span>
            <div class="icon success"></div>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="删除" v-if="showDelete" width="50" align="center">
        <template slot-scope="scope">
          <span>
            <el-link
              type="danger"
              icon="el-icon-delete"
              :underline="false"
              @click="() => $emit('onDelete', scope)"
            ></el-link>
          </span>
        </template>
      </el-table-column>
      <template slot="empty">
        <empty />
      </template>
    </el-table>
  </div>
</template>
<script>
import userinfo from "@/mixins/userinfo.js";
import typeTag from "./typeTag.vue";
export default {
  mixins: [userinfo],
  components: { typeTag },
  props: {
    search: {
      type: String,
    },
    tableData: {
      type: Array,
      default: () => [],
    },
    showDelete: {
      type: Boolean,
      default: false,
    },
    showSearch: {
      type: Boolean,
      default: true,
    },
    defaultExpandAll: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {};
  },
  mounted() {},
  methods: {
    baoguang() {
      console.log(this.auth);
      if (this.auth) {
        this.$router.push({ name: "allexposureForm" });
      } else {
        this.$alert("曝光前请先个人实名认证", "提示", {
          confirmButtonText: "确定",
          callback: () => {
            this.$store.dispatch("user/toAccountAuth");
          },
        });
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.exposureList {
  & ::v-deep .el-table__expanded-cell {
    padding: 0;
  }

  .search {
    height: 50px;
    display: flex;
    align-items: center;
  }

  .icon {
    width: 60px;
    height: 20px;
    margin-left: 6px;
  }

  .flex {
    display: flex;
    align-items: center;
  }

  .success {
    background-image: url(~@/static/image/yirenzheng.png);
    background-size: 100%;
  }

  .content {
    background: #f7f8f9;
    padding: 14px 24px 14px 64px;

    h1 {
      font-size: 14px;
      font-family: "Noto Sans SC";
      font-weight: 400;
      color: #666666;
      line-height: 20px;
    }

    p {
      font-size: 14px;
      font-family: "Noto Sans SC";
      font-weight: 400;
      color: #262626;
      line-height: 28px;
    }
  }
}
</style>
